/* TUFTÉO MOTION — apparitions au scroll + brins de laine (léger, accessible) */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- apparitions au scroll --- */
  if (!reduced && 'IntersectionObserver' in window) {
    var sections = document.querySelectorAll('.shopify-section[id*="template--"]');
    if (sections.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('tuf-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

      sections.forEach(function (s, i) {
        if (i === 0) return; // jamais le hero : LCP intouchable
        s.classList.add('tuf-reveal');
        io.observe(s);
      });
    }
  }

  /* --- brins de laine à l'ajout au panier --- */
  if (!reduced && typeof Element.prototype.animate === 'function') {
    var COLORS = ['#E8542F', '#FFD23F', '#2D5BFF', '#FDF8EF', '#1C1410'];
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('button[name="add"]');
      if (!btn || btn.disabled) return;
      var r = btn.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      for (var i = 0; i < 26; i++) {
        var brin = document.createElement('div');
        brin.className = 'tuf-brin';
        brin.style.background = COLORS[i % COLORS.length];
        brin.style.left = cx + 'px';
        brin.style.top = cy + 'px';
        document.body.appendChild(brin);
        var ang = Math.random() * Math.PI * 2;
        var v = 60 + Math.random() * 120;
        var dx = Math.cos(ang) * v * 1.6;
        var dy = Math.sin(ang) * v - 60;
        var rot = (Math.random() * 720 - 360);
        var anim = brin.animate([
          { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + dx + 'px,' + (dy + 190) + 'px) rotate(' + rot + 'deg)', opacity: 0 }
        ], { duration: 750 + Math.random() * 350, easing: 'cubic-bezier(.17,.67,.4,1)' });
        anim.onfinish = (function (el) { return function () { el.remove(); }; })(brin);
      }
    }, { passive: true });
  }
})();